import React from 'react';

const LeftContent = ({ countdown }) => {
  const textColor =
        countdown > 10
            ? 'text-[#FFCC21]'
            : countdown > 5
            ? 'text-yellow-300'
            : 'text-red-400';

        const bounceClass = countdown <= 5 && countdown !== 0 ? 'animate-bounce' : '';

    return (
        <div className="flex flex-col items-center">
            <div className={`w-[4rem] h-[4rem] sm:w-28 sm:h-28 md:w-32 md:h-32 lg:w-36 lg:h-36 rounded-full bg-[#022E7E] flex items-center justify-center ${textColor} ${bounceClass}`}>
                <span className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-wide notranslate" translate="no">
                    {countdown}
                </span>
            </div>

            <div className="w-full text-center mt-3 px-4 py-1 bg-[#022E7E] text-[#FFCC21] rounded-full text-base sm:text-lg font-semibold shadow-sm">
                Time
            </div>
        </div>
    );

};  

export default LeftContent;
